import { useState, useEffect } from 'react';
import { orderBy } from 'lodash';

import { useMutationResync } from '../mutation/resync';
import { useMutationUpdateOrganization } from '../mutation/updateOrganization';
import { adminApi, OrganizationStatistics } from '../../api/admin';

const convertDataToHospitals = (adminStat: OrganizationStatistics[]) => {
  return orderBy(adminStat ?? [], (hospital) => hospital.casesAmount, 'desc');
};

export const useQueryAdministration = () => {
  const [hospitals, setHospitals] = useState<OrganizationStatistics[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await adminApi.getStatistics();
      setHospitals(convertDataToHospitals(response.data));
    } catch (error) {
      // console.error('Failed to fetch administration statistics:', error);
      setHospitals([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const { mutation: performResync } = useMutationResync({
    onCompleted: () => fetchData(),
  });

  const { mutation: performUpdate } = useMutationUpdateOrganization({
    onCompleted: () => fetchData(),
  });

  const resync = (organizationSlug?: string) => {
    // console.log('Resyncing organization:', organizationSlug);
    performResync({ variables: { organizationSlug } });
  };

  const updateOrganization = (slug: string, active: boolean) => {
    performUpdate({ variables: { organizationSlug: slug, organizationActive: active } });
  };

  return { hospitals, loading, resync, updateOrganization };
};
